
import { neighborhoods } from '../../../mocks/relocation';

export default function NeighborhoodsSection() {
  return (
    <section id="neighborhoods" className="py-20 px-6 bg-stone-50 scroll-mt-32">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-teal-700 bg-teal-50 text-sm font-medium px-4 py-1.5 rounded-full mb-4">
            <i className="ri-map-pin-line"></i>
            Find Your Fit
          </span>
          <h2 className="text-3xl font-bold text-gray-900 mb-3">Discover Your Perfect Neighborhood</h2>
          <p className="text-gray-500 max-w-xl mx-auto text-sm">
            From brand-new master-planned communities to charming historic districts, Roseville has a neighborhood for every lifestyle.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {neighborhoods.map((hood) => (
            <article key={hood.id} className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow group">
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={hood.image}
                  alt={`${hood.name} neighborhood in Roseville California`}
                  title={`${hood.name} - ${hood.tagline} - Roseville neighborhood`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm text-xs font-semibold text-gray-700 px-3 py-1 rounded-full">
                  {hood.vibe}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-bold text-gray-900 mb-1">{hood.name}</h3>
                <p className="text-teal-600 text-xs font-medium mb-3">{hood.tagline}</p>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{hood.description}</p>

                <div className="grid grid-cols-3 gap-3 mb-4">
                  <div className="text-center bg-gray-50 rounded-lg py-2.5 px-2">
                    <p className="text-xs text-gray-400 mb-0.5">Median Price</p>
                    <p className="text-sm font-bold text-gray-900">{hood.medianPrice}</p>
                  </div>
                  <div className="text-center bg-gray-50 rounded-lg py-2.5 px-2">
                    <p className="text-xs text-gray-400 mb-0.5">Walk Score</p>
                    <p className="text-sm font-bold text-gray-900">{hood.walkScore}</p>
                  </div>
                  <div className="text-center bg-gray-50 rounded-lg py-2.5 px-2">
                    <p className="text-xs text-gray-400 mb-0.5">Schools</p>
                    <p className="text-sm font-bold text-gray-900">{hood.schoolRating}</p>
                  </div>
                </div>

                <div className="flex flex-wrap gap-1.5">
                  {hood.highlights.map((h) => (
                    <span key={h} className="text-xs bg-teal-50 text-teal-700 px-2.5 py-1 rounded-full">{h}</span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
